import './style.scss'

function Loader({ width = 30, height = 30 }) {
  return <div className="loader" style={{ width, height }} />
}

export default Loader
